/* eslint-disable */

import Vue from 'vue';
import Router from 'vue-router';

import RouteInfo from '../components/RouteInfo/RouteInfo'
import RouteInfoBase from '../components/RouteInfo/RouteInfoBase'
import RouteInfoRoute from '../components/RouteInfo/RouteInfoRoute'
import RouteInfoStop from '../components/StopInfo/RouteInfoStop'

import Closest from '../components/Closest/Closest'
import ClosestRoute from '../components/Closest/ClosestRoute'
import ClosestStopByRoute from '../components/Closest/ClosestStopByRoute'

import PointToPoint from '../components/P2p/PointToPoint'
import RouteInfoStopGroup from "@/components/StopInfo/RouteInfoStopGroup";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/routeinfo',
      name: 'routeTab',
      component: RouteInfo,

      children: [
        {
          path: '',
          name: 'routeinfoBase',
          component: RouteInfoBase,
        },
        {
          path: 'route/:id',
          name: 'routeinfo',
          component: RouteInfoRoute,
          props: true,

          children: [
            {
              path: 'stop/:stopid',
              name: 'routeStopDetail',
              props: true,
            },
          ],
        },
        {
          path: 'stop/:id',
          name: 'stopinfo',
          component: RouteInfoStop,
          props: true,

          children: [],
        },
        {
          path: 'stopGroup/:id',
          name: 'stopgroup',
          component: RouteInfoStopGroup,
          props: true,
        },
      ],
    },
    {
      path: '/closest',
      name: 'closestTab',
      component: Closest,

      children: [
        {
          path: '',
          name: 'closestRoute',
          component: ClosestRoute,
          props: true,
        },
        {
          path: 'route/:id',
          name: 'closestStopByRoute',
          component: ClosestStopByRoute,
          props: true,
        },

      ],
    },
    {
      path: '/p2p',
      name: 'p2pTab',
      component: PointToPoint,
    },
    {
      path: '*',
      component: RouteInfo,
      children: [
        {
          path: '',
          component: RouteInfoBase,
        },
      ],
    }
  ]
})
